import { useState } from 'react';

import Editor from '../../WSIGEditor/WSIGEditor';
import NibDialog from '../NibDialog/NibDialog';
import NibInput from '../NibInput/NibInput';

const InputDialogRichText = ({
  formik,
  label,
  name,
  helperText,
  editorButtonList = [],
  encodeURI = true,
  required = false,
  width = '40%',
}) => {
  const [isOpen, setOpen] = useState(false);
  const [editorContent, setEditorContent] = useState('');

  const handleDialogOpen = () => {
    setEditorContent(decodeURIComponent(formik.values[name] || ''));
    setOpen(true);
  };

  const onDialogClose = (isAgree) => {
    if (isAgree) {
      formik.setFieldTouched(name, true);
      formik.setFieldValue(name, encodeURI ? encodeURIComponent(editorContent) : editorContent);
    }
    setOpen(false);
  };

  const handleChange = (value) => {
    setEditorContent(value);
  };

  return (
    <>
      <NibDialog useButtons={true} open={isOpen} onClose={onDialogClose} width={width}>
        <Editor content={editorContent} onChange={handleChange} editorButtonList={editorButtonList} />
      </NibDialog>
      <NibInput
        required={required}
        hideOnInit={false}
        tools={['info', 'add']}
        label={label}
        placeholder="Click to open popup window"
        helperText={helperText}
        variant={'filled'}
        onAdd={handleDialogOpen}
        onClick={handleDialogOpen}
        style={{ width: '100%' }}
        inputStyles={{ cursor: 'pointer' }}
        error={formik.touched[name] && formik.errors[name]}
      />
    </>
  );
};

export default InputDialogRichText;
